var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTransparent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17.4 20.1",
    style: {
      enableBackground: "new 0 0 17.4 20.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3DB394;}\n\t.st1{fill:#FCBD13;}\n\t.st2{fill:#264653;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 5,
    transform: "matrix(0.5 -0.866 0.866 0.5 -4.3621 12.5922)",
    className: "st0",
    width: 17.4,
    height: 10.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "8.7,8.3 8.7,20.1 17.4,15.1 17.4,8.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "0,11.9 8.7,11.9 8.7,0 0,5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "8.7,8.3 8.7,0 1.9,11.9 8.7,11.9 8.7,20.1 8.7,20.1 15.6,8.3  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTransparent);
export default __webpack_public_path__ + "static/media/iconTransparent.72fe54ebd1e0cfbb7bb66d11b3749468.svg";
export { ForwardRef as ReactComponent };